
import { saveGoodsTask, savePddGoods } from "@user-center/api/erp.ts";
export async function save1688GoodsData(data: any,cb=(res:any)=>{}) {
    const collectionGoodsLogDTOList = data.map((v) => ({
      offerId: v.offerId,
      itemName: v.subject,
      itemMainImage: v.productImage?.images[0],
      itemSale: v.productSaleInfo?.amountOnSale,
      itemMinPrice: v.productSaleInfo?.priceRangeList[0].price,
      itemMaxPrice:
        v.productSaleInfo?.priceRangeList[
          v.productSaleInfo.priceRangeList.length - 1
        ].price,
    }));
    let res: any = await saveGoodsTask({
      sourceInfo: 1,
      collectionGoodsLogDTOList,
    });
    cb(res)
   
  }


